import React from 'react';
import { IconProps } from '../types';
const MinecraftBell: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="1" width="1" height="1" fill="rgba(95, 53, 35, 255)" />
<rect x="3" y="1" width="1" height="1" fill="rgba(131, 91, 74, 255)" />
<rect x="4" y="1" width="1" height="1" fill="rgba(95, 53, 35, 255)" />
<rect x="5" y="1" width="1" height="1" fill="rgba(95, 53, 35, 255)" />
<rect x="6" y="1" width="1" height="1" fill="rgba(64, 33, 20, 255)" />
<rect x="7" y="1" width="1" height="1" fill="rgba(64, 33, 20, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(95, 53, 35, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(95, 53, 35, 255)" />
<rect x="10" y="1" width="1" height="1" fill="rgba(95, 53, 35, 255)" />
<rect x="11" y="1" width="1" height="1" fill="rgba(64, 33, 20, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(95, 53, 35, 255)" />
<rect x="13" y="1" width="1" height="1" fill="rgba(64, 33, 20, 255)" />
<rect x="2" y="2" width="1" height="1" fill="rgba(64, 33, 20, 255)" />
<rect x="3" y="2" width="1" height="1" fill="rgba(95, 53, 35, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(64, 33, 20, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(51, 25, 14, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(51, 25, 14, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(51, 25, 14, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(64, 33, 20, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(64, 33, 20, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(64, 33, 20, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(51, 25, 14, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(64, 33, 20, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(51, 25, 14, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(180, 101, 42, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(180, 101, 42, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(180, 101, 42, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(245, 204, 39, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(180, 101, 42, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(254, 255, 189, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(254, 255, 189, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(180, 101, 42, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(254, 255, 189, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(254, 255, 189, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(254, 255, 189, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(254, 255, 189, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(255, 246, 141, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(180, 101, 42, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(180, 101, 42, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(254, 214, 57, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(255, 236, 79, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(211, 150, 50, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(156, 79, 22, 255)" />
</svg>);
export default MinecraftBell;